<template lang="html">

  <section class="wrapper mi-cv">
    <div class="wrapper-cv container row-start ais" v-if="!!cv">

      <aside class="left">

        <nav class="breadcrumb">
          <router-link :to="$t('enlaces.home')">Inicio</router-link>
          <router-link :to="$t('enlaces.home')">Mi perfil</router-link>
        </nav>

        <img class="logo-esic" src="@/assets/img/logo-esic.svg" alt="Logo esic" v-if="type == 'bs'">
        <img class="logo-esic" src="@/assets/img/logo-uni.svg" alt="Logo uni" v-if="type == 'uni'">
        <h2 class="nombre">{{cv.personales.nombre}} {{cv.personales.apellidos}}</h2>

        <contacto :info="cv.personales" :perfildigital="cv.profesional.linkedin"></contacto>
        <idiomas :info="cv.idiomas"></idiomas>
        <movilidad :info="cv.interes"></movilidad>
        <documentacion :info="cv.documentos" :infoPersonal="cv.personales"></documentacion>
      </aside>
      <main class="right">
        <h2 class="nombre">{{cv.personales.nombre}} {{cv.personales.apellidos}}</h2>
        <resumen :data="cv.resumenCV"></resumen>
        <formacion :info="cv.academicos"></formacion>
        <experiencia :info="cv.profesional.experiencia"></experiencia>
        <software :info="cv.interes.programas"></software>
      </main>
      <section class="bottom">
        <h2>Información solo para UDP</h2>
        <div class="column-container row-start ais">
          <div class="column">
            <datospersonales :tienePermisoTrabajo="cv.tienePermisoTrabajo" :personales="cv.personales"
              :discapacidad="cv.interes" :trabajando="cv.profesional.ocupado"></datospersonales>
          </div>
          <div class="column" v-if="usertype == 'Empleo'">
            <salario :info="cv.profesional.idSalario"></salario>
          </div>
          <div class="column">
            <intereses :busqueda_activa="cv.profesional.busqueda_activa" :intereses="cv.interes.intereses"></intereses>
          </div>
        </div>
      </section>

      <div class="btn-container row-center">
        <a @click="generateCV" v-if="!!cv.urlCV" target="_blank" class="btn">Generar CV</a>
      </div>

    </div>

    <div class="loading" v-if="!!!cv"></div>

  </section>

</template>

<script lang="js">


  import { mapGetters, mapActions } from 'vuex';

  import contacto from './mi-cv/contacto';
  import documentacion from './mi-cv/documentacion';
  import experiencia from './mi-cv/experiencia';
  import formacion from './mi-cv/formacion';
  import idiomas from './mi-cv/idiomas';
  import movilidad from './mi-cv/movilidad';
  import resumen from './mi-cv/resumen';
  import software from './mi-cv/software';
  import datospersonales from './mi-cv/datos-personales';
  import salario from './mi-cv/salario';
  import intereses from './mi-cv/intereses';

  export default {
    name: 'mi-cv',
    mounted() {
      this.requestCV();
    },
    components: {
      documentacion,
      contacto,
      experiencia,
      formacion,
      idiomas,
      movilidad,
      resumen,
      software,
      datospersonales,
      salario,
      intereses,
    },
    methods: {
      ...mapActions(['requestCV', 'canEditCv']),
      generateCV() {
        this.canEditCv().then(r => {
          if (r) {
            window.open(this.cv.urlCV, '_blank');
          }
        });
      }
    },
    computed: {
      ...mapGetters({
        cv: 'getCV',
        usertype : 'getusertype',
        type : 'getType'
      })
    }
  }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/views/mi-cv.vue